import * as React from "react";
import { forwardRef } from "react";
const SvgIconExports = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 15, height: 15, viewBox: "0 0 15 15", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M9 15V3L15 9L9 15Z", fill: "currentColor" }), /* @__PURE__ */ React.createElement("path", { d: "M6 12H9V6H6C3.03968 5.70397 0.633311 3.48321 0.101112 0.556114L0 0L7.15495e-08 6C1.11065e-07 9.31371 2.68629 12 6 12Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgIconExports);
export { ForwardRef as ReactComponent };
